























import { Vue, Component, Prop } from "vue-property-decorator";
import { collections } from "@/configs/firebase";
import logger from "@/configs/logger";

@Component
export default class Rebuttals extends Vue {
  @Prop({ required: true }) title!: string;
  @Prop({ required: true }) type!: "opening" | "closing";

  pages: any[] = [];
  dialog: boolean = false;

  created() {
    this.fetchPages();
  }

  async fetchPages() {
    try {
      const snapshot = await collections.scriptPromptPages
        .doc(this.pageId)
        .collection("pages")
        .get();
      this.pages = snapshot.docs.map(doc => doc.data());
      logger("log", "rebuttals pages ", this.pages);
    } catch (err) {
      logger("error", "rebuttals fetch error", err);
    }
  }

  get pageId(): string {
    if (this.type === "closing") {
      return "closing_rebuttals";
    }
    return "opening_rebuttals";
  }
}
